import React, { useState } from 'react';
import { FaEnvelope } from 'react-icons/fa';  // Importer l'icône "message" de Font Awesome
 

const ChatWindows = () => {
    // Déclare un état pour savoir si la fenêtre de chat est ouverte ou fermée
    const [isChatOpen, setIsChatOpen] = useState(true);
  
    // État pour gérer le message en cours de saisie
    const [currentMessage, setCurrentMessage] = useState("");
  
    // État pour gérer la liste des messages
    const [messages, setMessages] = useState(["Bienvenue dans la messagerie ! Comment puis-je vous aider ?"]);
  
    // Fonction pour ouvrir ou fermer la fenêtre de chat
    const toggleChatWindow = () => {
      setIsChatOpen(!isChatOpen);
    };
  
    // Fonction pour envoyer un message
    const sendMessage = () => {
      if (currentMessage.trim()) {
        setMessages([...messages, currentMessage]); // Ajoute le message à la liste
        setCurrentMessage(""); // Réinitialise le champ de saisie
      }
    };
  
    // Fonction pour gérer l'envoi avec "Entrée"
    const handleKeyPress = (e) => {
      if (e.key === "Enter") {
        sendMessage();
      }
    };
  
    return (
      <div>
        {/* L'icône de messagerie */}
        <div className="icon-container" onClick={toggleChatWindow}>
          <FaEnvelope className="messaging-icon" size={30} color="#fff" />
        </div>
  
        {/* Fenêtre de chat */}
        {isChatOpen && (
          <div className="chat-window">
            <div className="chat-header">
              <span>Messagerie</span>
              <button onClick={toggleChatWindow} className="close-btn">X</button>
            </div>
            <div className="chat-body">
              {messages.map((msg, index) => (
                <p key={index}>{msg}</p> // Affiche chaque message
              ))}
            </div>
            <div className="chat-footer">
              <input
                type="text"
                placeholder="Tapez votre message..."
                value={currentMessage}
                onChange={(e) => setCurrentMessage(e.target.value)}
                onKeyPress={handleKeyPress} // Gère la touche "Entrée"
              />
              <button onClick={sendMessage}>Envoyer</button>
            </div>
          </div>
        )}
      </div>
    );
    
  };

export default ChatWindows;
